// Shared formatters

// Money in MXN with thousands separator: 1498 -> "1,498.00"
export const fmtMoney = (n) =>
  (Number(n) || 0).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

// Plain integer with thousands separator: 12345 -> "12,345"
export const fmtInt = (n) => (Number(n) || 0).toLocaleString('es-MX');
